import { Controller } from "@hotwired/stimulus"
import { install, uninstall } from "@github/hotkey"

export default class extends Controller {
  connect() {
    for (const el of this.element.querySelectorAll('[data-hotkey]')) {
      // console.log('Installing hotkey on:', el, 'with hotkey:', el.dataset.hotkey)
      install(el)
    }
  }

  disconnect() {
    uninstall(this.element)
  }
}
